export default "__VITE_ASSET__yU4$KpwY__"